module.exports = __webpack_public_path__ + "media/images/riders/ANNE_TAUBER-523de74b2b737d32a23608b64bb062dc.png";